import EducationPage from "./EducationPage";
export default EducationPage;
